import getImaginaryUrl, { ImaginaryParams } from './getImaginaryUrl'

export default function getResolutionVariations(
  config: ImaginaryParams,

  /**
   * @depreacted Configure width/height in the config prop
   */
  width?: number,

  /**
   * @depreacted Configure width/height in the config prop
   */
  height?: number,
) {
  const itemWidth = width ?? config.width
  const itemHeight = height ?? config.height

  const src1x = getImaginaryUrl({
    ...config,
    width: itemWidth,
    height: itemHeight,
  })

  const src2x = getImaginaryUrl({
    ...config,
    areaheight: config.areaheight ? config.areaheight * 2 : undefined,
    areawidth: config.areawidth ? config.areawidth * 2 : undefined,
    top: config.top ? config.top * 2 : undefined,
    left: config.left ? config.left * 2 : undefined,
    width: itemWidth ? itemWidth * 2 : undefined,
    height: itemHeight ? itemHeight * 2 : undefined,
  })
  return [src1x, src2x]
}
